var map = {
	"./404.svg": 63983,
	"./Feedback.svg": 50164,
	"./Feedback1.svg": 88429,
	"./biaoda.svg": 88267,
	"./chayi.svg": 72827,
	"./close.svg": 88655,
	"./diyerror.svg": 60649,
	"./diyjinggao.svg": 22978,
	"./diytishi.svg": 9526,
	"./down.svg": 94073,
	"./edit.svg": 47713,
	"./gailan.svg": 63619,
	"./gexinghua.svg": 22485,
	"./gongneng.svg": 2448,
	"./lashen.svg": 56652,
	"./myCard.svg": 21205,
	"./myData.svg": 78247,
	"./playIcon.svg": 96824,
	"./shaixuan.svg": 74038,
	"./shangchuan.svg": 37043,
	"./tiqu.svg": 69398,
	"./wenhao.svg": 33391,
	"./wenjian.svg": 34899,
	"./wgcna.svg": 63221,
	"./xiazai.svg": 58323,
	"./yijian.svg": 6109,
	"./zhuanlu.svg": 17980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;